import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { translations } from "./translations";

const STORAGE_KEY = "birrou.lang";
const SUPPORTED = ["fr", "en"];

const I18nContext = createContext({
  lang: "fr",
  setLang: () => {},
  t: translations.fr,
});

function detectInitialLang() {
  if (typeof window === "undefined") return "fr";
  try {
    const saved = window.localStorage.getItem(STORAGE_KEY);
    if (saved && SUPPORTED.includes(saved)) return saved;
  } catch (_) {
    /* ignore */
  }
  return "fr";
}

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(detectInitialLang);

  useEffect(() => {
    document.documentElement.lang = lang;
    try {
      window.localStorage.setItem(STORAGE_KEY, lang);
    } catch (_) {
      /* ignore */
    }
  }, [lang]);

  const value = useMemo(
    () => ({
      lang,
      setLang: (l) => SUPPORTED.includes(l) && setLangState(l),
      t: translations[lang] || translations.fr,
    }),
    [lang]
  );

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  return useContext(I18nContext);
}
